import SlideFrame from "./_SlideFrame";

export default function SlideWhereWeFit() {
  return (
    <SlideFrame tag="08 · Market">
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-6">
          <p className="overline mb-6">Non-competitive by design</p>
          <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium">
            We operate <em className="italic text-primary">behind</em> the lender —<br />
            never in front of one.
          </h2>
          <p className="mt-8 text-foreground/75 leading-relaxed max-w-xl">
            We&rsquo;re a partner, not a platform-play. Your borrowers stay your borrowers.
          </p>
        </div>
        <div className="lg:col-span-6 space-y-3">
          {[
            "We don't originate loans",
            "We don't compete for your customers",
            "But we treat them like our own",
          ].map((t, i) => (
            <div key={i} className="flex items-center gap-5 border border-foreground/20 p-6 bg-white">
              <span className="font-mono-data text-xs text-muted-foreground">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-display text-2xl">{t}</span>
            </div>
          ))}
        </div>
      </div>
    </SlideFrame>
  );
}
